module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oMt7UQ/tc-custom/9781504075695.jpg?1705201883523",
      "alt": "This image is the cover for the book Bat Wing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bat Wing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A London PI investigates a case of voodoo and vampirism in this classic mystery from the golden age of detective fiction.")])]), _c('p', [_vm._v("When detective Paul Harley is visited by Col. Juan Menendez, he is intrigued by the man’s mysterious tale of being followed and threatened by a shadowy figure. As an officer of the Spanish West Indies, Menendez had reason to flee his colonial properties. But now he finds that England is not far enough to escape his enemies.")]), _vm._v(" Soon Harley and his associate, Mr. Knox find themselves embroiled in a dangerous investigation in which they must contend with witchcraft, vampirism, and murder. First published in 1921, "), _c('i', [_vm._v("Bat Wing")]), _vm._v(" is a suspenseful tale by the author of the Fu-Manchu novels.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sax Rohmer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sax Rohmer (1883–1959) was a pioneering and prolific author of crime fiction, best known for his series of novels featuring the archetypal evil genius Dr. Fu-Manchu.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    MysteriousPress.com/Open Road\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0